module.exports = __webpack_public_path__ + "img/falabella.ee749b5.png";